export const addQuizQuestionImage = (payload?: any) => ({
    type: "@saga/QUESTION_QUIZ_ADD_IMAGE",
    payload
});

